import {Component, inject} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HeaderParamsService} from '../../services/header-params.service';

@Component({
  selector: 'app-footer-component',
  imports: [RouterModule],
  templateUrl: './footer-component.html',
  styleUrl: './footer-component.sass',
})
export class FooterComponent {
  readonly headerParamsService = inject(HeaderParamsService);
}
